
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[...app]",
      function () {
        return require("private-next-pages/[...app].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[...app]"])
      });
    }
  